import { Axios } from 'commonUtils';
import { APP } from 'components/ui/redux/Actions';
import { ceData } from 'components/CeData';

class UiStateApi {
  fetchState = async () => {
    const { data, request } = await Axios.get('/spr/ui/server-state');

    // request is following redirects and retrieving html response from login page when user is not logged in
    const userNotLoggedIn = request.responseURL.includes('/login');
    if (userNotLoggedIn) {
      window.location.replace(request.responseURL);
      return;
    }

    return data;
  };

  reloadState = async () => {
    const data = await this.fetchState();
    if (data) {
      const context = ceData.update(data.context);
      window.SERVER_STATE = Object.assign(window.SERVER_STATE ?? {}, data, { context });
      window.ReduxStore.dispatch(APP.reloadServerState(context));
    }
  };
}

export default UiStateApi;
